import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Icon, Input, Badge, Spin, message, Button } from 'antd';
import * as S from '../styles';
import { useBatchJob } from '../../../../../context/BatchJobContext';
import axiosCall from '../../../../../utils/services/interceptor';
import { Document, Page } from 'react-pdf';
import axios from 'axios';
import { saveByteArray } from '../../../../../utils/javascript';
import { PreviewPageWithObserver } from '../../../../ComplexDocumentDesign/ComplexPdfInserts/InsertPreviewModal';
import { proceedProof } from '../../../../../utils/services/statusMonitoringAPI';
import { getSearchMetaKeys } from '../../../../../utils/services/statusMonitoringAPI';
import ProofSearchSelect from './ProofSearchSelect';
import { proofApproval } from '../../../../../utils/services/statusMonitoringAPI';
import { LoaderContainer } from '../../../../TemplateSection/styles';
import Loader from '../../../../../components/Loader';
import { BATCH_JOBS_DASHBOARD as trans } from '../translationValues';
import { useTranslation } from 'react-i18next';
import { PreviewIframe } from '../../../../ComplexEmailDesign/ComplexEmailPreview/styles';

const NAMESPACE = ['BATCH_JOBS_DASHBOARD'];

export function ProofViewer({ format, selectedTemplate, templates, proofs, ...props }) {
    const { t } = useTranslation(NAMESPACE);

    const STATIC_STATS_KEYS = ['uniq_id', 'uniq_name', ''];

    const { proffDataList, setProffDataList, batchId,  proofsApproved, setProofsApproved,totalProofCount,setTotalProofCount} = props;
    const [pdfurl, setPdfUrl] = useState();
    const [emailData, setEmailData] = useState();
    const [numPages, setNumPages] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [totalCount, setTotalCount] = useState(0);
    const [currentView, setCurrentView] = useState(2);
    const searchKeys = STATIC_STATS_KEYS;
    const isApproved = useRef(false);
    const currentChannel = useRef('print');

    const getPreview = async (url, payload) => {
        currentChannel.current = 'print';
        let req = { dataSet: payload };
        let res;
        try {
            let response = await axiosCall('post', url, req, true, false, true);
            if (response?.status === 200) {
                res = { status: response?.status, url: saveByteArray('kk77', response.data, false) };
            }
            setPdfUrl(res?.url);
            setIsLoading(false);
        }
        catch {
            //handle later
        }
    }

    const getEmailPreview = async(url,payload)=>{
        currentChannel.current = 'email';
        let req = { dataSet: payload };
        try {
            let response = await axiosCall('post', url, req);
            if (response?.status === 200) {
                setEmailData(response?.data);
            }
            setIsLoading(false);
        }
        catch {
            //handle later
        }
    }

    const getMetaKeys = async () => {
        try{
            const res = await getSearchMetaKeys(batchId);
        }
        catch{
            //handle later
        }
    }

    useEffect(() => {
        if(format.toLowerCase() === 'print' || format.toLowerCase().includes('multi')){
            proffDataList && getPreview(proffDataList[0].documentURL, proffDataList[0].dataSet);
        }
        else if (format.toLowerCase() === 'email'){
            proffDataList && getEmailPreview(proffDataList[0].documentURL, proffDataList[0].dataSet);            
        }
    }, [proffDataList])

    useEffect(() => {
        getMetaKeys();
    }, [])

    const getProofsList = async () => {
        let payload = {
            search: [
                {
                    fieldName: 'stage',
                    value: 'yet_to_start'
                },
                {
                    fieldName: 'channel',
                    value: format.toLowerCase()
                }
            ],
            jobId: String(batchId)
        }
        try {
            let response = await proceedProof(payload);
            if (response && response?.data) {
                getPreview(response?.data[4]?.documentURL, response?.data[4]?.dataSet)
                setProffDataList(response?.data);
            }
        }
        catch{
            //hanlde later
        }
    }

    const getProofsListForMultiChannel = async (channelId) => {
        let payload = {
            search: [
                {
                    fieldName: 'stage',
                    value: 'yet_to_start'
                },
                {
                    fieldName: 'channel',
                    value: channelId.toLowerCase()
                }
            ],
            jobId: String(batchId)
        }
        try {
            let response = await proceedProof(payload);
            if (response && response?.data) {
                setTotalProofCount(response?.dataCount);
                if (channelId === 'PRINT') {
                    getPreview(response?.data[0]?.documentURL, response?.data[0]?.dataSet)
                }
                else if (channelId === 'EMAIL') {
                    getEmailPreview(response?.data[0]?.documentURL, response?.data[0]?.dataSet)
                }
                setProffDataList(response?.data);
            }
        }
        catch {
            //handle later
        }
    }

    const isMultichannel = format === 'MULTICHANNEL' || format === 'MULTI CHANNEL' || format === 'HYBRID' ||
        (proofs && proofs.length > 0 && proofs.some(p => p.channel));

    const getUniqueChannels = () => {
        if (!proofs || proofs.length === 0) return [];
        const channels = [...new Set(proofs.map(p => p.channel))].filter(Boolean);
        return channels.map(ch => ({
            id: ch,
            label: ch,
            count: proofs.filter(p => p.channel === ch).length
        }));
    };

    const actualChannels = proofs && proofs.length > 0 ? getUniqueChannels() : [];
    const initialChannel = actualChannels.length > 0 ? actualChannels[0].id :
        (isMultichannel ? 'PRINT' : format);

    const [selectedChannel, setSelectedChannel] = useState(initialChannel);
    const [selectedProofNumber, setSelectedProofNumber] = useState(0);
    const [viewMode, setViewMode] = useState('desktop');
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedFilters, setSelectedFilters] = useState([]);

    const [showSearch, setShowSearch] = useState(false);
    const [selectedProofs, setSelectedProofs] = useState([]);

    const mockProofs = [
        {
            id: 1,
            name: 'Sarah Johnson',
            email: 'sarah.johnson@example.com',
            phone: '+44 7700 900123',
            address: '123 Example Street',
            city: 'London',
            postcode: 'SW1A 1AA',
            company: 'Go Inspire',
            companyAddress: 'PO Box 227',
            companyCity: 'Rotherham',
            companyPostcode: 'S98 1PB',
            date: '24 December 2025',
            ref: 'REF:4TV',
            customerId: 'CUS7',
            subject: 'We Missed Your Service Visit - Let\'s Make It Right',
            message: 'We wanted to get you an annual service visit with us, but we didn\'t invite you to book it in like we should have. We apologize for this oversight and would like to make it up to you.',
        },
        {
            id: 2,
            name: 'Michael Chen',
            email: 'michael.chen@example.com',
            phone: '+44 7700 900456',
            address: '456 Park Avenue',
            city: 'Manchester',
            postcode: 'M1 1AE',
            company: 'Go Inspire',
            companyAddress: 'PO Box 227',
            companyCity: 'Rotherham',
            companyPostcode: 'S98 1PB',
            date: '24 December 2025',
            ref: 'REF:8XY',
            customerId: 'CUS12',
            subject: 'Important Service Update',
            message: 'Thank you for your continued support. We wanted to reach out regarding your annual maintenance schedule.',
        },
        {
            id: 3,
            name: 'Emma Williams',
            email: 'emma.williams@example.com',
            phone: '+44 7700 900789',
            address: '789 Queen Street',
            city: 'Birmingham',
            postcode: 'B1 1AA',
            company: 'Go Inspire',
            companyAddress: 'PO Box 227',
            companyCity: 'Rotherham',
            companyPostcode: 'S98 1PB',
            date: '24 December 2025',
            ref: 'REF:2AB',
            customerId: 'CUS23',
            subject: 'Your Service Appointment',
            message: 'We have an important update regarding your upcoming service visit.',
        },
        {
            id: 4,
            name: 'James Taylor',
            email: 'james.taylor@example.com',
            phone: '+44 7700 900321',
            address: '321 High Street',
            city: 'Leeds',
            postcode: 'LS1 1AA',
            company: 'Go Inspire',
            companyAddress: 'PO Box 227',
            companyCity: 'Rotherham',
            companyPostcode: 'S98 1PB',
            date: '24 December 2025',
            ref: 'REF:5CD',
            customerId: 'CUS34',
            subject: 'Annual Service Reminder',
            message: 'It\'s time for your annual service check. We\'d like to schedule a convenient time for your visit.',
        },
    ];

    const getChannels = () => {
        if (actualChannels.length > 0) return actualChannels;

        if (format === 'MULTICHANNEL' || format === 'MULTI CHANNEL' || format === 'HYBRID') {
            return [
                { id: 'EMAIL', label: 'EMAIL', count: selectedChannel.toLowerCase() === 'email'? totalProofCount : '0' },
                // { id: 'SMS', label: 'SMS', count: mockProofs.length },
                { id: 'PRINT', label: 'PRINT', count: selectedChannel.toLowerCase() === 'print'?totalProofCount : '0' },
            ];
        }
        return [{ id: format, label: format, count: totalProofCount}];
    };

    const channels = getChannels();

    const getProofsForChannel = () => {
        if (!proofs || proofs.length === 0) return mockProofs;
        return proofs.filter(p => p.channel === selectedChannel);
    };

    const channelProofs = getProofsForChannel();
    const maxProofNumber = proffDataList?.length || 0;
    const currentProof = channelProofs[selectedProofNumber - 1] || mockProofs[selectedProofNumber - 1] || mockProofs[0];

    const handleChannelChange = (channelId) => {
        setIsLoading(true);
        setSelectedChannel(channelId);
        getProofsListForMultiChannel(channelId);
        setSelectedProofNumber(0);
    };

    const handlePrevProof = () => {
        if (selectedProofNumber > 0) {
            const newIndex = selectedProofNumber - 1;
            setSelectedProofNumber(newIndex);
            setIsLoading(true);
            (selectedChannel.toLowerCase() === 'print' || format.toLowerCase() === 'print')
                ? getPreview(
                    proffDataList[newIndex].documentURL,
                    proffDataList[newIndex].dataSet
                )
                : getEmailPreview(
                    proffDataList[newIndex].documentURL,
                    proffDataList[newIndex].dataSet
                );
        }
    };

    const handleNextProof = () => {
        if (selectedProofNumber < maxProofNumber - 1) {
            const newIndex = selectedProofNumber + 1;
            setSelectedProofNumber(newIndex);

            selectedChannel.toLowerCase() === 'print'
                ? getPreview(
                    proffDataList[newIndex].documentURL,
                    proffDataList[newIndex].dataSet
                )
                : getEmailPreview(
                    proffDataList[newIndex].documentURL,
                    proffDataList[newIndex].dataSet
                );
        }
    };

    const handleSearchToggle = () => {
        setShowSearch(!showSearch);
        setSearchQuery('');
    };

    const handleSearchChange = (e) => setSearchQuery(e.target.value);

    const handleSelectFirst5 = () => {
        setSelectedProofs(proffDataList.length);
        setSelectedProofNumber(0);
    };

    const handleSelectLast5 = async () => {
        try{
        await getProofsList();
        }
        catch{
            //hadle later
        }
        setSelectedProofs(proffDataList.length);
        setSelectedProofNumber(4);
    };

    const getFilteredProofs = () => {
        if (!searchQuery) return mockProofs;
        const query = searchQuery.toLowerCase();
        return mockProofs.filter(proof =>
            proof.name.toLowerCase().includes(query) ||
            proof.email.toLowerCase().includes(query) ||
            proof.phone.includes(query) ||
            proof.city.toLowerCase().includes(query) ||
            proof.postcode.toLowerCase().includes(query) ||
            proof.ref.toLowerCase().includes(query) ||
            proof.customerId.toLowerCase().includes(query)
        );
    };

    const filteredProofs = getFilteredProofs();

    const previewPortalContainerId = 'preview-portal';

    const valueDataSet = useMemo(() => {
        const data = {};
        searchKeys.forEach(key => {
            data[key.charAt(0).toUpperCase() + key.slice(1)] = [...new Set(mockProofs.map(p => p[key]))];
        });
        return data;
    }, [mockProofs]);

    const handleApproveProofs = async()=>{
        try{
            await proofApproval(batchId,isApproved.current);
        }
        catch{
            //handle later
        }        
    }


    return (
        <S.PVContainer>
            <S.PVControlsWrapper>
                <S.PVFlexRow>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <S.PVSectionHeader>{t(trans.PROOFS_HEADER.key, trans.PROOFS_HEADER.value)}</S.PVSectionHeader>
                        {channels.map((channel) => (
                            <S.PVTabButton
                                key={channel.id}
                                active={selectedChannel === channel.id}
                                onClick={() => handleChannelChange(channel.id)}
                            >
                                {channel.label} {channel.count > 0 && ` (${channel.count})`}
                            </S.PVTabButton>
                        ))}
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <S.PVSectionHeader>{t(trans.SELECT_PROOF_HEADER.key, trans.SELECT_PROOF_HEADER.value)}</S.PVSectionHeader>
                            {Array.from({ length: proffDataList?.length }, (_, index) => (
                                <S.PVProofNumberButton
                                    key={index}
                                    active={selectedProofNumber === index}
                                    onClick={() => {
                                        setIsLoading(true)
                                         format === 'PRINT' || selectedChannel === 'PRINT' ? getPreview(
                                            proffDataList[index].documentURL,
                                            proffDataList[index].dataSet
                                        ) : getEmailPreview(proffDataList[index].documentURL,
                                            proffDataList[index].dataSet);
                                        setSelectedProofNumber(index);
                                    }}
                                >
                                    #{index + 1}
                                </S.PVProofNumberButton>
                            ))}
                        </div>

                        {selectedChannel.toUpperCase() === 'EMAIL' && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <S.PVSectionHeader>{t(trans.VIEW_MODE_HEADER.key, trans.VIEW_MODE_HEADER.value)}</S.PVSectionHeader>
                                <S.PVViewModeButton
                                    active={viewMode === 'desktop'}
                                    onClick={() =>  {setCurrentView(2);setViewMode('desktop')}}
                                >
                                    <Icon type="desktop" />
                                    {t(trans.DESKTOP_MODE.key, trans.DESKTOP_MODE.value)}
                                </S.PVViewModeButton>
                                <S.PVViewModeButton
                                    active={viewMode === 'mobile'}
                                    onClick={() =>  {setCurrentView(3);setViewMode('mobile')}}
                                >
                                    <Icon type="mobile" />
                                    {t(trans.MOBILE_MODE.key, trans.MOBILE_MODE.value)}
                                </S.PVViewModeButton>
                            </div>
                        )}
                    </div>
                </S.PVFlexRow>

                <S.PVQuickActionsArea>
                    <S.PVSectionHeader>{t(trans.QUICK_ACTIONS_HEADER.key, trans.QUICK_ACTIONS_HEADER.value)}</S.PVSectionHeader>
                    {totalProofCount > 4 && <S.PVActionButton variant="cyan" onClick={handleSelectFirst5}>
                        {t(trans.FIRST_5_PROOFS.key, trans.FIRST_5_PROOFS.value)}
                    </S.PVActionButton>}
                    {totalProofCount > 5  && <S.PVActionButton variant="cyan" onClick={handleSelectLast5}>
                        {t(trans.LAST_5_PROOFS.key, trans.LAST_5_PROOFS.value)}
                    </S.PVActionButton>}
                    <S.PVActionButton active={showSearch} onClick={handleSearchToggle}>
                        <Icon type="search" />
                        {t(trans.SEARCH_PROOFS.key, trans.SEARCH_PROOFS.value)}
                    </S.PVActionButton>

                    {showSearch && (
                        <S.PVSearchContainer style={{ width: '100%', maxWidth: '600px' }}>
                            <ProofSearchSelect
                                setIsLoading={setIsLoading}
                                selectedChannel={selectedChannel}
                                getEmailPreview={getEmailPreview}
                                getPreview={getPreview}
                                keyDataSet={searchKeys}
                                valueDataSet={valueDataSet}
                                selectedFilters={selectedFilters}
                                setSelectedFilters={setSelectedFilters}
                                placeholder={t(trans.SEARCH_KEY_VALUE_PLACEHOLDER.key, trans.SEARCH_KEY_VALUE_PLACEHOLDER.value)}
                                fullWidth
                                isDynamicKeyValue
                                allowValuesforKeys={searchKeys}
                                batchId={batchId}
                                format={format}
                                setProffDataList={setProffDataList}
                                setTotalProofCount={setTotalProofCount}
                            />
                        </S.PVSearchContainer>
                    )}

                    {showSearch && searchQuery && (
                        <Badge
                            count={filteredProofs.length}
                            style={{ backgroundColor: '#f3f4f6', color: '#374151', boxShadow: 'none', border: 'none' }}
                        />
                    )}
                </S.PVQuickActionsArea>

                {showSearch && searchQuery && filteredProofs.length > 0 && (
                    <S.PVResultsGrid>
                        {filteredProofs.map((proof) => (
                            <S.PVResultButton
                                key={proof.id}
                                onClick={() => {
                                    setSelectedProofNumber(proof.id);
                                    setShowSearch(false);
                                    setSearchQuery('');
                                }}
                            >
                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937', marginBottom: '4px' }}>#{proof.id} - {proof.name}</div>
                                <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                    <div>{proof.email}</div>
                                    <div>{proof.city} - {proof.postcode}</div>
                                    <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                                        <span style={{ backgroundColor: '#f3f4f6', padding: '2px 8px', borderRadius: '4px' }}>{proof.ref}</span>
                                        <span style={{ backgroundColor: '#f3f4f6', padding: '2px 8px', borderRadius: '4px' }}>{proof.customerId}</span>
                                    </div>
                                </div>
                            </S.PVResultButton>
                        ))}
                    </S.PVResultsGrid>
                )}

                {showSearch && searchQuery && filteredProofs.length === 0 && (
                    <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #e5e7eb', textAlign: 'center', padding: '32px 0' }}>
                        <Icon type="search" style={{ fontSize: '32px', color: '#9ca3af', marginBottom: '8px' }} />
                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#4b5563' }}>{t(trans.NO_PROOFS_FOUND.key, trans.NO_PROOFS_FOUND.value)}</div>
                        <div style={{ fontSize: '12px', color: '#6b7280' }}>{t(trans.TRY_DIFFERENT_SEARCH.key, trans.TRY_DIFFERENT_SEARCH.value)}</div>
                    </div>
                )}
            </S.PVControlsWrapper>

            <S.PVPreviewArea>
                <S.PVNavArrow
                    direction="left"
                    onClick={handlePrevProof}
                    disabled={selectedProofNumber === 0}
                >
                    <Icon type="left" />
                </S.PVNavArrow>

                <S.PVNavArrow
                    direction="right"
                    onClick={handleNextProof}
                    disabled={selectedProofNumber === maxProofNumber - 1}
                >
                    <Icon type="right" />
                </S.PVNavArrow>

                <S.PVDocumentPreview>
                    <S.PVPaper mode={viewMode}>
                        { (format === 'PRINT' || selectedChannel.toLowerCase() === 'print') && (isLoading ?
                            <LoaderContainer style={{ marginTop: '25%' }}>
                                <Loader />
                            </LoaderContainer> :
                            <Document
                                //  file={{ data: new Uint8Array(byteArray) }}
                                file={pdfurl}
                                // file="https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf"
                                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                                error={t(trans.FAILED_TO_LOAD_PDF.key, trans.FAILED_TO_LOAD_PDF.value)}
                            >
                                {numPages &&
                                    Array.from(new Array(numPages), (_, index) => (
                                        <Page key={index} pageNumber={index + 1} />
                                    ))}
                            </Document>
                            )}
                        {(format === 'EMAIL' || selectedChannel.toLowerCase() === 'email') &&
                         (isLoading? 
                         <LoaderContainer style={{ marginTop: '25%' }}>
                                <Loader />
                            </LoaderContainer> :<PreviewIframe style={{ position: 'relative', top: 4, height: 'calc(100vh - 150px)'}} currentView={currentView}>
                            { emailData && <iframe srcDoc={emailData} style={{ width: '100%', height: 'calc(100vh - 175px)' }}/>}
                        </PreviewIframe>
                        )}
                    </S.PVPaper>
                </S.PVDocumentPreview>
            </S.PVPreviewArea>

            <S.PVApprovalSection>
                <S.PVApprovalFlex>
                    <S.PVIconBox>
                        <Icon type="file-text" style={{ fontSize: '20px', color: '#ffffff' }} />
                    </S.PVIconBox>
                    <div style={{ flex: 1 }}>
                        <h3 style={{ fontSize: '14px', fontWeight: '700', color: '#1f2937', marginBottom: '8px' }}>{t(trans.APPROVE_PROOFS_TITLE.key, trans.APPROVE_PROOFS_TITLE.value)}</h3>
                        <p style={{ fontSize: '12px', color: '#4b5563', marginBottom: '16px' }}>
                            {t(trans.APPROVE_PROOFS_DESC.key, {
                                channel: selectedChannel,
                                defaultValue: trans.APPROVE_PROOFS_DESC.value,
                            })}
                        </p>
                        <S.PVApprovalButton
                            approved={isApproved.current}

                            onClick={() => { isApproved.current = !isApproved.current ;handleApproveProofs();setProofsApproved(!!isApproved.current)}}
                        >
                            {isApproved.current
                                ? t(trans.PROOFS_APPROVED_BUTTON.key, trans.PROOFS_APPROVED_BUTTON.value)
                                : t(trans.APPROVE_PROOFS_BUTTON.key, trans.APPROVE_PROOFS_BUTTON.value)}
                        </S.PVApprovalButton>
                    </div>
                </S.PVApprovalFlex>
            </S.PVApprovalSection>
        </S.PVContainer>
    );
}




